import React from "react";

export const GrafodataLogo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 140, height: 28 },
    default: { width: 170, height: 36 },
    large: { width: 220, height: 48 },
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center text-primary ${className}`}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 170 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="logo-pulse"
      >
        {/* Continuous pulse/heartbeat line */}
        <path
          d="M0 18 L8 18 L12 8 L16 28 L20 14 L24 22 L28 18 L36 18"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />

        {/* grafodata text */}
        <text
          x="42"
          y="24"
          fontFamily="Inter, sans-serif"
          fontSize="20"
          fontWeight="600"
          fill="currentColor"
          letterSpacing="-0.02em"
        >
          grafodata
        </text>

        {/* Continuing pulse after text */}
        <path
          d="M148 18 L156 18"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </div>
  );
};

export const GrafodataLogoIcon = ({ className = "" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`text-primary ${className}`}
    >
      {/* Pulse icon */}
      <path
        d="M2 16 L6 16 L10 6 L14 26 L18 10 L22 22 L26 16 L30 16"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
